<template>
    <a-config-provider :autoInsertSpaceInButton="false" :locale="locale">
        <div class="download">
            <a-breadcrumb separator=">">
                <a-breadcrumb-item>
                    <router-link to="/home">
                        <img src="../../assets/home/icon-home.svg" style="margin: 0 4px 4px 0" />首页
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item>相关下载</a-breadcrumb-item>
            </a-breadcrumb>

            <div class="download-body">
                <div class="right-content">
                    <div class="subtitle">相关下载</div>
                    <div class="container">
                        <a-spin :spinning="loading">
                            <div class="download-list">
                                <template v-if="downloadList.length > 0">
                                    <div class="list-item" v-for="item in downloadList" :key="item.fileId">
                                        <div :class="['icon', getIconClass(item.fileType)]"></div>
                                        <div class="main">
                                            <div class="title" :title="item.fileName" @click="downloadFile(item)">
                                                {{ item.fileName }}
                                            </div>
                                            <div class="other">{{ item.fileType }} | {{ item.fileSize }}</div>
                                        </div>
                                        <div class="download-icon" title="下载" @click="downloadFile(item)"></div>
                                    </div>
                                </template>
                                <a-empty style="margin-top: 28px" v-else />
                            </div>
                        </a-spin>
                        <a-pagination
                            v-if="total > 0"
                            class="sw-pagination"
                            v-model="current"
                            :defaultPageSize="pageSize"
                            :pageSizeOptions="pageSizeOptions"
                            :total="total"
                            show-quick-jumper
                            show-size-changer
                            @showSizeChange="onChange"
                            @change="onChange"
                        />
                    </div>
                </div>
            </div>
        </div>
    </a-config-provider>
</template>

<script>
import { queryDownloadList, queryFileDetail } from '../../common/api';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import axios from 'axios';

export default {
    components: {},

    data() {
        return {
            pageSizeOptions: ['10', '20', '30', '40', '50'],
            current: 1,
            pageSize: 10,
            total: 0,
            locale: zhCN,
            loading: true,
            downloadList: [],
            extMap: {
                word: ['doc', 'docx', 'txt', 'rtf'],
                exec: ['xls', 'xlsx', 'csv'],
                pptx: ['ppt', 'pptx'],
                pdf: ['pdf'],
                img: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg']
            }
        };
    },

    mounted() {
        this.getDownloadList();
    },

    methods: {
        getIconClass(ext) {
            for (const [type, extensions] of Object.entries(this.extMap)) {
                if (extensions.includes(ext.toLowerCase())) {
                    return type;
                }
            }

            return 'file';
        },

        async getDownloadList() {
            this.loading = true;
            try {
                const { data } = await queryDownloadList();
                if (data) {
                    this.total = data.length;
                    // 前端分页
                    const start = (this.current - 1) * this.pageSize;
                    const end = start + this.pageSize;
                    this.downloadList = data.slice(start, end);
                }
            } catch (error) {
                // 失败时使用默认数据
                this.downloadList = [];
                this.total = this.downloadList.length;
            } finally {
                this.loading = false;
            }
        },

        async downloadFile(file) {
            if (file.fileId) {
                try {
                    const { data } = await queryFileDetail(file.fileId);
                    if (data && data.downloadUrl && data.name) {
                        // 去掉文件类型后缀
                        this.downloadByBlob(data.downloadUrl, data.name);
                    }
                } catch (error) {
                    console.error('获取文件详情失败:', error);
                }
            }
        },

        downloadByBlob(url, fileName) {
            axios.get(url, { responseType: 'blob' }).then(res => {
                const blob = new Blob([res.data]);
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = fileName ?? true;
                link.click();
                URL.revokeObjectURL(link.href);
            });
        },

        onChange(page, size) {
            this.current = page;
            this.pageSize = size;
            this.getDownloadList();
        }
    }
};
</script>

<style lang="scss" scoped>
.download {
    width: 1200px;
    padding-bottom: 78px;

    &-body {
        display: flex;
        align-items: flex-start;

        .right-content {
            flex-grow: 1;
            background: #ffffff;
            border-radius: 4px;
            padding: 16px 24px;

            .subtitle {
                height: 48px;
                font-size: 24px;
                font-weight: 600;
                letter-spacing: 0;
                color: #005299;
                background: url(../../assets/test-service/split.png) bottom no-repeat;
                background-size: 100% 8px;
            }

            .container {
                padding: 16px 0;
                font-size: 16px;
            }

            .download-list {
                margin-bottom: 16px;
                min-height: 30vh;

                .list-item {
                    width: 100%;
                    // height: 90px;
                    padding: 8px;
                    // border-radius: 4px;
                    // background: #f0f4fb;
                    // border: 1px solid #dfe8f8;
                    display: flex;
                    align-items: center;
                    // margin-bottom: 16px;

                    &:hover {
                        background: #f0f4fb;
                    }

                    .icon {
                        width: 20px;
                        height: 20px;
                        background: url(./imgs/icon-file.svg) no-repeat center center/cover;

                        &.exec {
                            background: url(./imgs/icon-excel.svg) no-repeat center center/cover;
                        }

                        &.word {
                            background: url(./imgs/icon-word.svg) no-repeat center center/cover;
                        }

                        &.pptx {
                            background: url(./imgs/icon-ppt.svg) no-repeat center center/cover;
                        }

                        &.pdf {
                            background: url(./imgs/icon-pdf.svg) no-repeat center center/cover;
                        }

                        &.img {
                            background: url(./imgs/icon-img.svg) no-repeat center center/cover;
                        }
                    }

                    .main {
                        width: calc(100% - 20px - 16px - 18px);
                        margin: 0 8px;
                        display: flex;
                        justify-content: space-between;

                        .title {
                            // font-size: 16px;
                            // color: #333333;
                            // font-weight: 600;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            cursor: pointer;
                        }

                        .other {
                            margin-top: 4px;
                            font-size: 14px;
                            color: #999999;
                            font-weight: 600;
                        }
                    }

                    .download-icon {
                        width: 18px;
                        height: 18px;
                        background: url(./imgs/icon-download.svg) no-repeat center center/cover;
                        cursor: pointer;
                    }
                }
            }

            .ant-pagination {
                display: flex;
                justify-content: flex-end;
            }
        }
    }
}
</style>
